import {Stack, Typography, Box} from '@mui/material';
import {ratingsToObj} from '../../utils/healthCalculations';

export const ResultCard = ({metric, config, isSmallScreen, isGalaxyFold, blurAndHide}) => {
  if (!metric) return null;

  return (
    <Stack
      className="progress-item"
      paddingLeft={isGalaxyFold ? 1 : 3}
      paddingRight={isGalaxyFold ? 1 : 3}
      marginBottom={2}
    >
      <Stack className="prograss-bar">
        <Typography
          color="black"
          variant="h4"
          component="h4"
          fontWeight="600"
          sx={{fontSize: isGalaxyFold ? '14px' : isSmallScreen ? '14px' : '17px'}}
        >
          {metric.name}
        </Typography>

        {metric.ratings && (
          <RatingDisplay
            metric={metric}
            blurAndHide={blurAndHide}
            isGalaxyFold={isGalaxyFold}
            isSmallScreen={isSmallScreen}
            config={config}
          />
        )}
      </Stack>

      <Stack display="flex" flexDirection="row" alignItems="center">
        <Typography
          color="black"
          variant="h4"
          component="h4"
          fontWeight="700"
          sx={{
            fontSize: isGalaxyFold ? '18px' : isSmallScreen ? '18px' : '23px',
            marginRight: !metric.symbol ? '0px' : '15px',
            filter: blurAndHide ? 'blur(8px)' : 'blur(0px)',
          }}
        >
          {Math.round(metric.value)}
          {metric.diastolicbp != null && `/${Math.round(metric.diastolicbp)}`}
          {metric.percentSign}
        </Typography>

        {metric.symbol && <MetricSymbol metric={metric} isSmallScreen={isSmallScreen} isGalaxyFold={isGalaxyFold} />}
      </Stack>
    </Stack>
  );
};

const RatingDisplay = ({metric, blurAndHide, isGalaxyFold, isSmallScreen, config}) => {
  const ratingObj = ratingsToObj(metric.ratings, metric.value);
  if (!ratingObj) return null;

  const iconSrc =
    config?.organization?.flags?.isAtpl || config?.organization?.flags?.isHelloHealth
      ? ratingObj.icon.replace('/others/', '/others/atplResultsIcon/orange_')
      : ratingObj.icon;

  return (
    <Stack display="flex" flexDirection="row" marginTop="4px">
      <img src={iconSrc} className="s-icon" alt="" style={{filter: blurAndHide ? 'blur(20px)' : 'blur(0px)'}} />
      <Typography
        color={blurAndHide ? 'black' : ratingObj?.color}
        variant="p"
        component="p"
        fontWeight="700"
        sx={{
          fontSize: isGalaxyFold ? '10px' : isSmallScreen ? '10px' : '12px',
          paddingLeft: '4px',
          filter: blurAndHide ? 'blur(12px)' : 'blur(0px)',
        }}
      >
        {ratingObj?.text}
      </Typography>
    </Stack>
  );
};

const MetricSymbol = ({metric, isSmallScreen, isGalaxyFold}) => (
  <Stack display="flex" justifyContent="center" alignItems="center">
    <img src={metric.symbol} width={isSmallScreen ? '24' : '26'} height={isSmallScreen ? '18' : '23'} alt="" />
    <Typography
      color="rgba(0, 0, 0, 0.65)"
      variant="p"
      component="p"
      fontWeight="700"
      sx={{
        fontSize: isGalaxyFold ? '10px' : isSmallScreen ? '8px' : '10px',
        marginTop: '4px',
      }}
    >
      {metric.label}
    </Typography>
  </Stack>
);
